/**
 * @desc getWfsReport
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.getWfsReport.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getWfsReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
